import { FetchError } from './fetchError';

export const responseFetcher = async (url: string, options?: RequestInit) => {
  let res: Response;
  try {
    res = await fetch(url, options);
  } catch (e) {
    throw FetchError.fromUnknownError(e, url);
  }

  if (!res.ok) {
    throw await FetchError.fromResponse(res);
  }

  return res;
};

export const jsonFetcher = async <DataType>(url: string, options?: RequestInit) => {
  const res = await responseFetcher(url, options);
  return res.json() as DataType;
};

export const defaultFetcher = async (key: string | [string, RequestInit]) => {
  const [url, options] = Array.isArray(key) ? key : [key, {}];
  return jsonFetcher(url, options);
};
